import React from "react";
import {Box, Button, Columns, Form, Heading} from "react-bulma-components";
import DepartmentSelector from "../Settings/Departments/DepartmentSelector";
import ContactSection from "../Contact/ContactSection";
import MovementTypePicker from "../Settings/MovementType/MovementTypePicker";
import MovementRatePicker from "./MovementRatePicker";
import useButtonSelect from "../../hooks/useButtonSelect";
import CashSaleSection from "../Contact/CashSaleSection";


export default function CustomerChargerSection({data, onChange, onCheck, departments, onDepartmentChange, movementRates, onMovementRateChange,
                                                   movementTypes, onMovementTypeChange, endpoint, onCustomerChange, addCashSale, onCashSaleChange}){

    const options = [
        {name: "Normal", value: "NORMAL"},
        {name: "Quote", value: "QUOTE"}
    ];

    const customerPaymentOptions = [
        {name:"", value: "BLANK"},
        {name: "BACS", value: "BACS"},
        {name: "CASH", value: "CASH"},
        {name: "CARD", value: "CARD"},
        {name: "DIRECT DEBIT", value: "DIRECT DEBIT"}
    ];

    const [statusOption, statusOptionInput] = useButtonSelect({
        label: "Status",
        initialValue: "NORMAL",
        prop: "movement_status",
        options: options,
        callback: onChange
    });

    const handleCustomerChange = e => {
        onCustomerChange(e, "customer");
    }

    return (
        <Box>
            <Columns>
                <Columns.Column>
                    <Columns>
                        <Columns.Column>
                            <ContactSection
                                title={"Customer"}
                                contactUpdate={handleCustomerChange}
                                endpoint={endpoint+"contacts"}
                                contact={data.customer || {}}
                                type={"CC"}
                            />
                        </Columns.Column>
                    </Columns>
                    {data.customer.is_cash_sale &&
                        <Box>
                            <Columns>
                                <Columns.Column>
                                    <Heading>Cash Sale</Heading>
                                </Columns.Column>
                                {data.cash_sale.length == 0 &&
                                <Columns.Column>
                                    <Button
                                        color={"success"}
                                        onClick={() => addCashSale()}
                                    >
                                        Add Cash Sale +
                                    </Button>
                                </Columns.Column>
                                }
                            </Columns>
                        </Box>
                    }
                    {data.customer.is_cash_sale &&
                        data.cash_sale.map((sale, index) => (
                            <Columns>
                                <Columns.Column>
                                    <CashSaleSection
                                        data={sale}
                                        index={index}
                                        addCashSale={addCashSale}
                                        onChange={onCashSaleChange}
                                    />
                                </Columns.Column>
                            </Columns>
                        ))
                    }
                </Columns.Column>
            </Columns>
            <Columns>
                <Columns.Column>
                    <Heading>Customer Charger Section</Heading>
                </Columns.Column>
            </Columns>
            <Columns>
                <Columns.Column>
                    <DepartmentSelector
                        name={"department"}
                        label={"Customer Charger"}
                        value={data.department}
                        options={departments}
                        onChange={onDepartmentChange}
                        editable={true}
                    />
                </Columns.Column>
                <Columns.Column>
                    {statusOptionInput}
                </Columns.Column>
            </Columns>
            <Columns>
                <Columns.Column>
                    <Form.Label>Vehicle/Goods To Move</Form.Label>
                    <Form.Input
                        type={"text"}
                        value={data.vehicle}
                        name={"vehicle"}
                        onChange={onChange}
                    />
                </Columns.Column>
                <Columns.Column>
                    <Form.Label>Delivery Date</Form.Label>
                    <Form.Input
                        type={"date"}
                        value={data.delivery_date}
                        name={"delivery_date"}
                        onChange={onChange}
                    />
                </Columns.Column>
                <Columns.Column>
                    <MovementTypePicker
                        options={movementTypes}
                        value={data.movement_type}
                        editable={true}
                        label={"Movement Type"}
                        onChange={onMovementTypeChange}
                    />
                </Columns.Column>
            </Columns>
            <Columns>
                <Columns.Column>
                    <Form.Label>Start Address</Form.Label>
                    <Form.Textarea
                        name={"start_address"}
                        value={data.start_address}
                        onChange={onChange}
                    />
                </Columns.Column>
                <Columns.Column>
                    <Form.Label>End Address</Form.Label>
                    <Form.Textarea
                        name={"end_address"}
                        value={data.end_address}
                        onChange={onChange}
                    />
                </Columns.Column>
                <Columns.Column>
                    <Form.Label>Start time (*)</Form.Label>
                    <Form.Input
                        type={"time"}
                        name={"start_time"}
                        value={data.start_time}
                        onChange={onChange}
                    />
                </Columns.Column>
                <Columns.Column>
                    <Form.Label>End time (*)</Form.Label>
                    <Form.Input
                        type={"time"}
                        name={"end_time"}
                        value={data.end_time}
                        onChange={onChange}
                    />
                </Columns.Column>
                <Columns.Column>
                    <Form.Label>Order Number</Form.Label>
                    <Form.Input
                        value={data.order_number}
                        name={"order_number"}
                        onChange={onChange}
                        type={"text"}
                    />
                </Columns.Column>
            </Columns>
            <Columns>
                <Columns.Column>
                    <MovementRatePicker
                        options={movementRates}
                        label={"Movement Rate"}
                        editable={true}
                        movement={data}
                        onChange={onMovementRateChange}
                    />
                </Columns.Column>
                <Columns.Column>
                    <Form.Label>Rate Comments</Form.Label>
                    <Form.Textarea
                        disabled={true}
                        value={data.movement_rate ? data.movement_rate.comments : ""}
                    />
                </Columns.Column>
                <Columns.Column>
                    <Form.Label>Cost Per Mile</Form.Label>
                    <Form.Input
                        name={"cost_per_mile"}
                        disabled={true}
                        value={data.movement_rate ? data.movement_rate.cost_per_mile : 0}
                        onChange={onChange}
                        type={"number"}
                    />
                </Columns.Column>
            </Columns>
            <Columns>
                <Columns.Column>
                    <Form.Label>Distance (Miles)</Form.Label>
                    <Form.Input
                        name={"miles"}
                        value={data.miles}
                        onChange={onChange}
                        type={"number"}
                    />
                </Columns.Column>
                <Columns.Column>
                    <Form.Label>Customer Charge</Form.Label>
                    <Form.Input
                        name={"cost"}
                        value={data.cost}
                        onChange={onChange}
                        type={"number"}
                        disabled={!data.cost_override}
                    />
                </Columns.Column>
                <Columns.Column>
                    <Form.Field>
                        <Form.Label>Cost Override</Form.Label>
                        <Form.Checkbox
                            name={"cost_override"}
                            checked={data.cost_override}
                            onChange={onCheck}
                        />
                    </Form.Field>
                </Columns.Column>
                <Columns.Column>
                    <Form.Label>Additional Customer Charge</Form.Label>
                    <Form.Input
                        name={"customer_additional_charge"}
                        value={data.customer_additional_charge}
                        onChange={onChange}
                        type={"number"}
                    />
                </Columns.Column>
                <Columns.Column>
                    <Form.Label>Total Customer Charge</Form.Label>
                    <Form.Input
                        disabled={true}
                        value={parseFloat(data.cost) + parseFloat(data.customer_additional_charge)}
                    />
                </Columns.Column>
            </Columns>
            <Columns>
                <Columns.Column>
                    <Form.Label>Customer Amount Paid</Form.Label>
                    <Form.Input
                        type={"number"}
                        value={data.customer_paid_amount}
                        onChange={onChange}
                        name={"customer_paid_amount"}
                    />
                </Columns.Column>
                <Columns.Column>
                    <Form.Label>Customer Payment Method</Form.Label>
                    <Form.Select
                      name={"customer_payment_method"}
                      value={data.customer_payment_method}
                      onChange={onChange}
                    >
                      {customerPaymentOptions.map(method => (
                          <option value={method.value}>{method.name}</option>
                      ))}
                    </Form.Select>
                </Columns.Column>
            </Columns>
            <Columns>
                <Columns.Column>
                    <Form.Label>Internal Comments</Form.Label>
                    <Form.Textarea
                        name={"comments"}
                        value={data.comments}
                        onChange={onChange}
                    />
                </Columns.Column>
            </Columns>
        </Box>
    )



}